import { Model } from 'pinia-orm';
import InterimInternalNote from './InterimInternalNote';
import InterimAttachment from './InterimAttachment';
import InterimJob from './InterimJob';
import Application from './Application';
import Job from './Job';
import InterimMatrixTypeValue from './InterimMatrixTypeValue';
import InterimSection from './InterimSection';
// import InterimConnectUser from './InterimConnectUser';

export default class Interim extends Model {

    static entity = 'interims';

    static fields() {
        return {
            id: this.uid(() => null),
            connect_mail: this.attr(null),
            company_contact_id: this.attr(null),
            section_id: this.attr(null),
            order: this.attr(null),
            name: this.string(''),
            contact_name: this.string(''),
            contact_mail: this.string(''),
            contact_phone: this.string(''),
            logo: this.string(''),
            linked: this.boolean(false),
            type: this.string(''),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // Relationships
            internal_notes: this.hasMany(InterimInternalNote, 'interim_id'),
            attachments: this.hasMany(InterimAttachment, 'interim_id'),
            interimJobs: this.hasMany(InterimJob, 'interim_id'),
            applications: this.hasMany(Application, 'interim_id'),
            jobs: this.belongsToMany(Job, InterimJob, 'interim_id', 'job_id'),
            matrixValues: this.hasMany(InterimMatrixTypeValue, 'interim_id'),
            section: this.belongsTo(InterimSection, 'section_id'),
            // connectUsers: this.hasMany(InterimConnectUser, 'interim_id'),
        };
    }
}
